"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
  };
  return function (d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
  }
  return t;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var React = require("react");
var ScoreTab_1 = require("../components/ScoreTab");
var LeftArrow_1 = require("../svgs/LeftArrow");
var RightArrow_1 = require("../svgs/RightArrow");
var common_1 = require("@shine-api/common");
var ScoreTabContainer = function (_super) {
  __extends(ScoreTabContainer, _super);
  function ScoreTabContainer(props) {
    var _this = _super.call(this, props) || this;
    _this.node = null;
    _this.state = {
      startIndex: 0
    };
    _this.calculateTabs = _this.calculateTabs.bind(_this);
    return _this;
  }
  ScoreTabContainer.prototype.componentDidMount = function () {
    common_1.track("Tab Selected - Quiet");
    window.addEventListener('resize', this.calculateTabs);
    this.calculateTabs();
  };
  ScoreTabContainer.prototype.componentWillUnmount = function () {
    window.removeEventListener('resize', this.calculateTabs);
  };
  ScoreTabContainer.prototype.calculateTabs = function () {
    if (!this.node) {
      return;
    }
    var scores = this.props.scores;
    var _a = this.state,
      startIndex = _a.startIndex,
      _b = _a.totalVisible,
      totalVisible = _b === void 0 ? scores.length : _b;
    var clientWidth = this.node.clientWidth;
    var minTabWidth = 145;
    var numberOfTabs = Math.floor(clientWidth / minTabWidth);
    var newTotalVisible = numberOfTabs > scores.length ? scores.length : numberOfTabs;
    if (newTotalVisible !== totalVisible) {
      var newStart = 0;
      return this.setState({
        totalVisible: newTotalVisible,
        startIndex: newStart
      });
    }
  };
  ScoreTabContainer.prototype.next = function () {
    var scores = this.props.scores;
    var _a = this.state,
      startIndex = _a.startIndex,
      _b = _a.totalVisible,
      totalVisible = _b === void 0 ? scores.length : _b;
    if (scores.length > totalVisible + startIndex) {
      this.setState({
        startIndex: startIndex + 1
      });
    }
  };
  ScoreTabContainer.prototype.previous = function () {
    var scores = this.props.scores;
    var _a = this.state,
      startIndex = _a.startIndex,
      _b = _a.totalVisible,
      totalVisible = _b === void 0 ? scores.length : _b;
    if (startIndex > 0) {
      this.setState({
        startIndex: startIndex - 1
      });
    }
  };
  ScoreTabContainer.prototype.render = function () {
    var _this = this;
    var _a = this.props,
      scores = _a.scores,
      selectedIndex = _a.selectedIndex,
      _selectTab = _a.selectTab;
    var _b = this.state,
      startIndex = _b.startIndex,
      _c = _b.totalVisible,
      totalVisible = _c === void 0 ? scores.length : _c;
    var disablePrevArrow = startIndex === 0 ? 'disabled' : '';
    var disableNextArrow = scores.length > totalVisible + startIndex ? '' : 'disabled';
    var enableNav = scores.length > totalVisible ? 'visible' : '';
    var tabs = scores.map(function (score, key) {
      return React.createElement(ScoreTab_1.ScoreTab, __assign({}, score, {
        key: key,
        selected: selectedIndex === key ? '-selected' : '',
        selectTab: function selectTab(name) {
          return _selectTab(key, name);
        }
      }));
    });
    return React.createElement("div", {
      className: 'ths-score-tab-container',
      ref: function ref(node) {
        return _this.node = node;
      }
    }, React.createElement("div", {
      className: "ths-score-tab-previous " + enableNav + " " + disablePrevArrow,
      onClick: function onClick() {
        return _this.previous();
      }
    }, React.createElement(LeftArrow_1.LeftArrow, null)), tabs.slice(startIndex, totalVisible + startIndex), React.createElement("div", {
      className: "ths-score-tab-next " + enableNav + " " + disableNextArrow,
      onClick: function onClick() {
        return _this.next();
      }
    }, React.createElement(RightArrow_1.RightArrow, null)));
  };
  return ScoreTabContainer;
}(React.Component);
exports.ScoreTabContainer = ScoreTabContainer;